// require('dotenv').config();

// eslint-disable-next-line no-console
console.log('node environment =====', process.env.REACT_APP_NODE_ENV);
let BaseUrl;
let BUCKET;
/*
 * Socket.IO lives on the API host itself (server/app.js attaches it to the same
 * HTTP server), so this is BaseUrl without the /api path. Mirrors desktop/src/config.js.
 */
let SocketUrl;

switch (process.env.REACT_APP_NODE_ENV) {
  case 'staging':
    BaseUrl = 'https://staging-api.get-shoot.com/api/';
    SocketUrl = 'https://staging-api.get-shoot.com';
    BUCKET = 'shoot-staging';
    break;
  case 'production':
    BaseUrl = 'https://api.get-shoot.com/api/';
    SocketUrl = 'https://api.get-shoot.com';
    BUCKET = 'shoot-production';
    break;
  default: // "development"
    BaseUrl = 'http://localhost:4000/api/';
    SocketUrl = 'http://localhost:4000';
    BUCKET = 'shoot-development';
    break;
}

module.exports = {
  BaseUrl,
  SocketUrl,
  BUCKET,
  BUILD_BUCKET: 'shoot-app-builds',
};
